import React from 'react';
import Map from './Map';
import Panel from './Panel';
import BtnBand from './BtnBand';
import './App.css';
class App extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      center: [],
      band: '-',
      satelliteVar: {
        satelliteLng: 119.1,
        stationPosition: [0,0],
        elevationAngle: 0,
        azimuthAngle: 0
      }
    }
    this.satellitePos = 119.1;
  }

  onChangeBand = (center, band) => {
    this.setState({ center: center, band: band });
  }

  onChangePosition = (position, elevationAngle, azimuthAngle) => {
    let satelliteVar = { ...this.state.satelliteVar };
    satelliteVar.stationPosition = position;
    satelliteVar.elevationAngle = elevationAngle;
    satelliteVar.azimuthAngle = azimuthAngle;
    this.setState({ satelliteVar });
  }

  render() {
    return (
      <div className="app-container">
        <Panel satelliteVar={this.state.satelliteVar} band={this.state.band} />
        <Map center={this.state.center} band={this.state.band} onChangePosition={this.onChangePosition} />
        <BtnBand onChangeBand={this.onChangeBand} />
      </div>
    );
  }
};

export default App;